<template>
  <div class="flex mr-4">
    <div class="search-full-container w-full h-full absolute left-0 top-0" :class="{'flex': showFullSearch}" v-show="showFullSearch">
      <vx-auto-suggest
        ref="navbarSearch"
        :autoFocus="showFullSearch"
        :data="navbarSearchAndPinList"
        search_key="title"
        background-overlay
        class="w-full"
        inputClassses="w-full vs-input-no-border vs-input-no-shdow-focus"
        icon="SearchIcon"
        placeholder="Search teachers or students"
        @input="hnd_search_query_update"
        @selected="selected"
        @closeSearchbar="showFullSearch = false">

        <template v-slot:group="{ group_name }">
          <p class="font-semibold text-primary">{{ group_name | title }}</p>
        </template>

        <!-- Teachers Suggestion -->
        <template v-slot:teachers="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img :src="suggestion.image" :alt="suggestion.name" class="w-8 h-8 mr-3 rounded-full">
              <div class="leading-none mt-1">
                <p>{{ suggestion.name }} {{ suggestion.last_name }}</p>
                <small>{{ suggestion.email }}</small>
              </div>
            </div>
          </div>
        </template>

        <!-- Students Suggestion -->
        <template v-slot:students="{ suggestion }">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <img :src="suggestion.image" :alt="suggestion.name" class="w-8 h-8 mr-3 rounded-full">
              <div class="leading-none mt-1">
                <p>{{ suggestion.name }} {{ suggestion.last_name }}</p>
                <small>{{ suggestion.email }}</small>
              </div>
            </div>
          </div>
        </template>

        <!-- No Items Slot -->
        <template v-slot:noResult="{ group_name }">
          <div class="flex items-center">
            <feather-icon icon="InfoIcon" svgClasses="h-5 w-5" class="mr-4" />
            <span>No results found.</span>
          </div>
        </template>

      </vx-auto-suggest>

      <div class="absolute right-0 h-full z-50">
        <feather-icon
          icon="XIcon"
          class="px-4 cursor-pointer h-full close-search-icon"
          @click="showFullSearch = false" />
      </div>
    </div>
    <feather-icon icon="SearchIcon" @click="showFullSearch = true" class="cursor-pointer navbar-fuzzy-search ml-4" />
  </div>
</template>

<script>
import VxAutoSuggest from '@/components/vx-auto-suggest/VxAutoSuggest.vue';
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    VxAutoSuggest
  },
  data() {
    return {
      showFullSearch: false,
    }
  },
  computed: {
    navbarSearchAndPinList() {
      return {
        teachers : {
          key: "name",
          data : this.$store.state.userManagement.teachers
        },
        students : {
          key: "name",
          data : this.$store.state.userManagement.students
        }
      }
    },
  },
  methods: {
    selected(item) {
      if(item['teachers'] && item['teachers'].role &&  item['teachers'].role == "teacher") this.$router.push("/teachers/" + item['teachers'].id).catch(() => {})
      else if(item['students'] && item['students'].role &&  item['students'].role == "student") this.$router.push("/students/" + item['students'].id).catch(() => {})
      this.showFullSearch = false;
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      this.$store.commit('TOGGLE_CONTENT_OVERLAY',  false)
      // this.$store.commit('TOGGLE_CONTENT_OVERLAY', query ? true : false)
    }
  },
  async created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
  },
}

</script>
